import * as fromDatatype from '../datatype-library/index';

export interface bl_sfa_sales_lead_label_list_hdr_RowInterface {
    guid:                       fromDatatype.GuidDataFieldInterface;
    namespace:                  fromDatatype.VarcharDatatypeInterface;
    applet_guid:                fromDatatype.GuidDataFieldInterface;
    module_guid:                fromDatatype.GuidDataFieldInterface;
    code:                       fromDatatype.VarcharDatatypeInterface;
    name:                       fromDatatype.VarcharDatatypeInterface;
    description:                fromDatatype.TextDatatypeInterface;
    acl_config:                 fromDatatype.JsonDatatypeInterface;
    acl_policy:                 fromDatatype.JsonDatatypeInterface;
    property_json:              fromDatatype.JsonDatatypeInterface;
    param_code:                 fromDatatype.VarcharDatatypeInterface;
    param_name:                 fromDatatype.VarcharDatatypeInterface;
    param_option_json:          fromDatatype.JsonDatatypeInterface;
    status:                     fromDatatype.VarcharDatatypeInterface;
    revision:                   fromDatatype.GuidDataFieldInterface;
    vrsn:                       fromDatatype.VarcharDatatypeInterface;
    created_date:               fromDatatype.TimestampTzDatatypeInterface;
    updated_date:               fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:	fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:	fromDatatype.GuidDataFieldInterface;
    label_type:                 fromDatatype.VarcharDatatypeInterface;
    obj_type:                   fromDatatype.VarcharDatatypeInterface;
    obj_code:                   fromDatatype.VarcharDatatypeInterface;
    obj_option:                 fromDatatype.TextDatatypeInterface;
    param_type:                 fromDatatype.VarcharDatatypeInterface;
    value_string:               fromDatatype.TextDatatypeInterface;
    value_file:                 fromDatatype.VarcharDatatypeInterface;
    value_numeric:              fromDatatype.IntegerDatatypeInterface;
    value_datetime:             fromDatatype.TimestampTzDatatypeInterface;
    value_json:                 fromDatatype.JsonDatatypeInterface;
}

export class  bl_sfa_sales_lead_label_list_hdr_RowClass implements bl_sfa_sales_lead_label_list_hdr_RowInterface {

    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    param_code: fromDatatype.VarcharDatatypeInterface;
    param_name: fromDatatype.VarcharDatatypeInterface;
    param_option_json: fromDatatype.JsonDatatypeInterface;
    status:     fromDatatype.VarcharDatatypeInterface;
    revision:   fromDatatype.GuidDataFieldInterface;
    vrsn:        fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date:  fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:	fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:	fromDatatype.GuidDataFieldInterface;
    label_type: fromDatatype.VarcharDatatypeInterface;
    obj_type:   fromDatatype.VarcharDatatypeInterface;
    obj_code:  fromDatatype.VarcharDatatypeInterface;
    obj_option: fromDatatype.TextDatatypeInterface;
    param_type: fromDatatype.VarcharDatatypeInterface;
    value_string: fromDatatype.TextDatatypeInterface;
    value_file:  fromDatatype.VarcharDatatypeInterface;
    value_numeric:  fromDatatype.IntegerDatatypeInterface;
    value_datetime:  fromDatatype.TimestampTzDatatypeInterface;
    value_json:      fromDatatype.JsonDatatypeInterface;
  
  }
  